import { Pipe, PipeTransform } from '@angular/core';
import { ConversationSource } from '@vendasta/meeting-analysis';

@Pipe({
  name: 'meetingAnalysisSource',
  standalone: true,
})
export class SourcePipe implements PipeTransform {
  transform(source: ConversationSource): string {
    switch (source) {
      case ConversationSource.CONVERSATION_SOURCE_GOOGLE_MEET:
        return 'COMMON.GOOGLE_MEET';
      case ConversationSource.CONVERSATION_SOURCE_TEAMS:
        return 'COMMON.MICROSOFT_TEAMS';
      case ConversationSource.CONVERSATION_SOURCE_ZOOM:
        return 'COMMON.ZOOM';
      default:
        return '';
    }
  }
}
